import React from "react";
import KioskPrinterSetting from "@pages/Applications/Kiosk/PrinterSettingShared";
import CashManagementSetting from "@pages/ApplicationSetting/CashManagementSetting";
import { MoneticValinaSetting } from "./ApplicationSettingMonetic/MoneticValinaSetting";

function Configuration({
    isConfigurationPrinterClicked,
    isConfigurationCashManagementClicked,
    rowData,
    setRowData,
    oneShop,
    setGlobalDataIsUpdated,
    isMoneticsPathsModalOpened,
    userID,
    shopId,
    franchiseID,
    appId,
    applicationChildrenId,
    setIsMoneticsPathsModalOpened,
    displayMode,
}: any) {
    return (
        <>
            {isConfigurationPrinterClicked && (
                <KioskPrinterSetting
                    rowData={rowData}
                    oneShop={oneShop}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                />
            )}

            {isConfigurationCashManagementClicked && (
                <CashManagementSetting
                    rowData={rowData}
                    setRowData={setRowData}
                    oneShop={oneShop}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                />
            )}

            {isMoneticsPathsModalOpened && (
                <MoneticValinaSetting
                    data={rowData}
                    infoData={{
                        userId: userID,
                        shopId: shopId,
                        franchiseId: franchiseID,
                        appId: appId,
                        appId_children: applicationChildrenId,
                    }}
                    setIsMoneticsPathsModalOpened={
                        setIsMoneticsPathsModalOpened
                    }
                    isMoneticsPathsModalOpened={isMoneticsPathsModalOpened}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                    displayMode={displayMode}
                />
            )}
        </>
    );
}

export default Configuration;
